import React from "react";
import { Popover, Input, Tag, Tooltip, Divider, Menu } from "antd";
import { CheckOutlined, CloseOutlined, EditOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { PACKAGE } from "../../../../../constants/designType";
import { checkNameFormat } from "../../../../../services/helper/nameFormatCheck";
import { getDefaultName } from "../../../../../services/helper/setDefaultName";
import { dropdownMenuItemsObj, EDIT_MODEL, getDisplayModelFiles, PACKAGE_DIE } from "../../../../../services/Andes_v2/channel/channelBuilder";
import { SPICE } from "../../../../../constants/libraryConstants";
import { DIE } from "../../../../../constants/componentType";

class ModelTitleItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      editNameId: "",
      inputValue: "",
    }
  }

  displayFiles = (id, modelType, modelIndex, type, files, comps, fileColors) => {
    const compToFiles = getDisplayModelFiles(comps, files, modelType, type)
    const fileItem = (file) => {
      return <>
        <span>{file.fileName}{file.type.toLowerCase() === SPICE ? "::" + file.subckt : null}</span>
        <span>
          {/* <Tag className="circle-tag" color="blue">{file.number}</Tag> */}
          {file.isExist
            ? <CloseOutlined
              className='delete-model-file-icon'
              onClick={(e) => { e.stopPropagation(); this.props.deleteModelFile({ modelType, modelIndex }, file, type) }}
            />
            : <Tooltip title={`Files ${file.fileName} has been deleted, the model is invalid.`}>
              <QuestionCircleOutlined className='file-not-exist-icon' />
            </Tooltip>}
        </span>
      </>
    }
    return <Popover
      trigger="click"
      placement="top"
      classNames={{ root: 'andes-v2-popover andes-v2-channel-builder-file-list-popover' }}
      content={<div className="andes-v2-channel-builder-file-list andes-v2-channel-builder-model-files-collapse">
        {
          Object.keys(compToFiles).map((compName, index) => <div className='file-box' key={`${id}-${compName}-model-files-display`}>
            <h5>{compName}</h5>
            <div className='input-group'>
              {compToFiles[compName].map((file = {}, i) => (
                <Tag
                  color={(fileColors[`${type}-${modelIndex}-${file.modelKey}`] || "").bgColor}
                  key={`file-${id}-${i}`}
                  title={`${file.fileName}${file.type.toLowerCase() === SPICE ? "::" + file.subckt : ""}`}
                  className="input-box"
                >
                  {fileItem(file)}
                </Tag>
              ))}
            </div>
            {index !== Object.keys(compToFiles).length - 1 && <Divider size="small" />}
          </div>)
        }
      </div>}
    >
      {/* <FileTextOutlined
        className={"channel-builder-icon" + (open ? " channel-builder-icon-selected" : "")}
        title="Display files"
        onClick={() => this.props.setFileVisibleList(id)}
      /> */}
      <div className="model-title-files-box clickable-ellipsis">
        {(Object.values(compToFiles) || []).flat().map((file, index) =>
          <Tag
            color={(fileColors[`${type}-${modelIndex}-${file.modelKey}`] || "").bgColor}
            key={`${id}-model-file-tag-${index}`}
            title={`${file.fileName}${file.type.toLowerCase() === SPICE ? "::" + file.subckt : ""}`}
          >
            {fileItem(file)}
          </Tag>)}
      </div>
    </Popover>
  }

  clickEdit = (id, modelType) => {
    const { modelTypeList } = this.props;
    const defaultName = modelType ? modelType : getDefaultName({
      nameList: modelTypeList,
      key: null,
      defaultKey: `Custom`
    })
    this.setState({ editNameId: id, inputValue: defaultName });
  }

  cancelEdit = (e) => {
    e && e.stopPropagation();
    this.setState({ inputValue: "", editNameId: "" });
  }

  confirmEdit = (e, modelIndex, type) => {
    e.stopPropagation();
    const { inputValue } = this.state;
    // const { modelTypeList } = this.props;
    const error = checkNameFormat(inputValue, { errorType: "Model Name", allowEmpty: true });
    if (error) {
      this.setState({ inputError: error });
      this.inputRef.focus();
      return;
    }
    // if (modelTypeList.includes(inputValue)) {
    //   this.setState({ inputError: `${inputValue} already exists!` });
    //   this.inputRef.focus();
    //   return;
    // }
    this.props.editModelType(inputValue, modelIndex, type);
    this.cancelEdit();
  }

  clickMenuItem = (e, modelType, modelIndex, type) => {
    e && e.stopPropagation();
    if (modelType === EDIT_MODEL) {
      return;
    }
    this.props.editModelType(modelType, modelIndex, type);
    this.cancelEdit();
  }

  editModel = (id, modelType, modelIndex, type, comps, designType) => {
    const { editNameId, inputValue, inputError } = this.state;
    return <Popover
      placement="top"
      content={
        <Menu
          mode='vertical'
          className='add-new-model-menu'
          selectable={false}
          items={[
            ...dropdownMenuItemsObj[designType === PACKAGE && comps[0].type === DIE ? PACKAGE_DIE : "default"],
            {
              label: <Tooltip title={inputError} open={inputError ? true : false} classNames={{ root: "aurora-error-tooltip" }} zIndex={2001}>
                <Input
                  ref={ref => this.inputRef = ref}
                  value={inputValue}
                  onChange={(e) => this.setState({ inputValue: e.target.value })}
                  onPressEnter={(e) => this.confirmEdit(e, modelIndex, type)}
                  placeholder='Model Name'
                  addonAfter={<>
                    <CheckOutlined
                      className='create-new-model-icon'
                      onClick={(e) => this.confirmEdit(e, modelIndex, type)} />
                    <CloseOutlined
                      className='create-new-model-icon mg-r-8'
                      onClick={(e) => this.cancelEdit(e)} />
                  </>}
                />
              </Tooltip>,
              key: EDIT_MODEL
            }
          ]}
          onClick={({ key: modelType, domEvent }) => this.clickMenuItem(domEvent, modelType, modelIndex, type)}
        />
      }
      open={editNameId === id}
      classNames={{ root: 'andes-v2-popover andes-v2-channel-builder-file-list-popover' }}
    >
      <EditOutlined
        title="Rename"
        className={"channel-builder-icon" + (editNameId === id ? " channel-builder-icon-selected" : "")}
        onClick={() => this.clickEdit(id, modelType)}
      />
    </Popover>
  }

  render() {
    const {
      id,
      txCompName,
      designType,
      rxCompName,
      modelTitleInfo,
      portMatchId,
      comps,
      fileColors
    } = this.props;
    const { modelType = "", type, modelIndex, width, otherModelType, otherModelTitleWidth, files } = modelTitleInfo;
    return (
      type === 'main-layout' ? <div className="pcb-title-box">
        <div className="tx-comp">{txCompName}</div>
        <div className="pcb">{designType === PACKAGE ? 'Package' : 'PCB'}</div>
        <div className="rx-comp">{rxCompName}</div>
      </div> : <div style={{ width, paddingRight: otherModelTitleWidth }}>
        <div className="model-title-box">
          {type === 'rx' ? this.props.addNewModelDropdownRender(id, modelIndex, type, 'rx-add-icon') : null}
          {modelType}
          {this.editModel(id, modelType, modelIndex, type, comps, designType)}
          {/* {this.displayFiles((fileVisibleList === "all" || fileVisibleList.includes(id)) && files.length > 0, id, modelType, modelIndex, type, files, comps)} */}
          <span title="Ports Match" className={'iconfont icon-xinpian_chip channel-builder-icon' + (portMatchId === id ? " channel-builder-icon-selected" : "")} onClick={() => this.props.openAutoPortMatch(id, modelType, modelIndex, type)}></span>
          <CloseOutlined title="Delete" className='channel-builder-icon channel-builder-icon-delete' onClick={() => this.props.deleteOldModel(modelIndex, type)} />
          <span className="other-model-title" style={{ width: otherModelTitleWidth }}>{otherModelType}</span>
          {type === 'tx' ? this.props.addNewModelDropdownRender(id, modelIndex, type, 'tx-add-icon') : null}
        </div>
        {this.displayFiles(id, modelType, modelIndex, type, files, comps, fileColors)}
      </div>
    )
  }
}

export default ModelTitleItem;